import { CheckCircle2 } from 'lucide-react'
import { Modal } from '@shared/ui/Modal'
import { Button } from '@shared/ui/Button'
import { ENV } from '@shared/config/env'
import styles from './PlanChangedResultModal.module.css'

interface PlanChangedResultModalProps {
  /** Название назначенного тарифа. null — смену отменили. */
  planName: string | null
  /** Сколько спишется при переходе, уже с валютой. */
  priceText?: string | null
  /** Дата ближайшего списания в локальном формате. */
  nextChargeDate?: string | null
  onClose: () => void
}

/**
 * Подтверждение отложенной смены тарифа.
 *
 * Главное, что человек должен унести с экрана, — что деньги спишутся не
 * сейчас, а в дату следующего платежа, и сколько именно.
 */
export const PlanChangedResultModal = ({
  planName,
  priceText,
  nextChargeDate,
  onClose,
}: PlanChangedResultModalProps) => {
  const variant = ENV.IS_TG ? 'bottomSheet' : 'center'

  const title = planName ? 'Тариф изменён' : 'Смена тарифа отменена'

  const text = (() => {
    if (!planName) {
      return 'Подписка продолжит продлеваться на текущем тарифе.'
    }
    const when = nextChargeDate
      ? `При следующем списании ${nextChargeDate}`
      : 'При следующем списании'
    return priceText
      ? `${when} с вас спишется ${priceText}, и подписка перейдёт на «${planName}». Текущий оплаченный период сохраняется полностью.`
      : `${when} подписка перейдёт на «${planName}». Текущий оплаченный период сохраняется полностью.`
  })()

  return (
    <Modal onClose={onClose} variant={variant} showClose>
      <div className={styles.content}>
        <div className={styles.iconWrapper}>
          <CheckCircle2 size={36} />
        </div>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.text}>{text}</p>
        <div className={styles.actions}>
          <Button onClick={onClose} block>
            ОК
          </Button>
        </div>
      </div>
    </Modal>
  )
}
